import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Button, Col, Row, Stack } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { BiMailSend } from 'react-icons/bi';
import { FormResponseDetailDto } from '../../commons/dtos/form-response-detail.dto';
import Paper from '../../components/Paper';
import PublicFormInput from '../../components/PublicFormInput';
import FormService from '../../services/form.service';
import {
  FormResponseEnum,
  FormResponseStatysType,
  IPatchFormResponseReq
} from '../../commons/interfaces/form-response.interface';

import './style.scss';

const formService = new FormService();

const FormResponseDetail = () => {
  const params = useParams();
  const {
    register,
    formState: { errors },
    setValue,
    getValues
  } = useForm();

  const [formResponse, setFormResponse] = useState<FormResponseDetailDto>();

  useEffect(() => {
    const fetchFormresponse = async () => {
      const formResponseId = params.formResponseId as string;
      const response = await formService.getFormResponse(formResponseId);

      _.forEach(response.data.responses, ({ question, answer }) => {
        setValue(question.id, answer);
      });

      setFormResponse(response.data);
    };

    fetchFormresponse();
  }, [params.formResponseId, setValue]);

  const handleClick = async (status: 'APPROVED' | 'REJECTED') => {
    const formResponseId = params.formResponseId as string;
    const requestData: IPatchFormResponseReq = { status };
    await formService.modifyFormResponse(formResponseId, requestData);
    setFormResponse((current) => ({ ...current, ...requestData } as FormResponseDetailDto));
  };

  const getBodyMail = () => {
    if (formResponse) {
      const { status, formType } = formResponse;

      return status === 'APPROVED' ? formType.approvalMessage : formType.disapprovalMessage;
    }

    return '';
  };

  const handleSendMailClick = () => {
    const body = getBodyMail();
    const mailUrl = `mailto:${formResponse?.customer.email}?body=${encodeURIComponent(body)}`;
    window.open(mailUrl);
  };

  return (
    <Paper className="form-response-container">
      <Row className="d-flex justify-content-center pt-4">
        <Col sm={12} className="form-container mb-5">
          <Stack gap={3}>
            <Paper className="form-title">
              <div className="mb-2">
                <span className="text-title">Respuesta {formResponse?.code}</span>
              </div>
              <div className="response-description">
                <div>
                  <b>Nombre del cliente: </b>
                  <span>{formResponse?.customer.name}</span>
                </div>
                <div>
                  <b>Correo electrónico: </b>
                  <span>{formResponse?.customer.email}</span>
                </div>
                <div>
                  <b>Número celular: </b>
                  <span>{formResponse?.customer.number}</span>
                </div>
                <div>
                  <b>Nombre de la empresa: </b>
                  <span>{formResponse?.customer.business.name}</span>
                </div>
                <div>
                  <b>RUC de la empresa: </b>
                  <span>{formResponse?.customer.business.ruc}</span>
                </div>
                <div>
                  <b>Estado: </b>
                  <span>{FormResponseEnum[formResponse?.status as FormResponseStatysType]}</span>
                </div>
              </div>
            </Paper>
            {_.map(formResponse?.responses, ({ question, ...response }) => (
              <PublicFormInput
                key={response.id}
                register={register}
                questionId={question.id}
                question={`${question.order}. ${question.question}`}
                type={question.type}
                options={question.options}
                errors={errors}
                currentValue={getValues(question.id) as string}
                disabled
              />
            ))}
            <Row className="justify-content-around">
              <Col sm="auto">
                <Button
                  className="btn-medium"
                  disabled={formResponse?.status !== 'PENDING'}
                  onClick={handleClick.bind(null, 'APPROVED')}>
                  Aprobar
                </Button>
              </Col>
              <Col sm="auto">
                <Button
                  className="btn-medium"
                  disabled={formResponse?.status !== 'PENDING'}
                  onClick={handleClick.bind(null, 'REJECTED')}>
                  Rechazar
                </Button>
              </Col>
              <Col sm="auto">
                <Button
                  className="btn-medium"
                  variant="outline-primary"
                  disabled={formResponse?.status === 'PENDING'}
                  onClick={handleSendMailClick}>
                  Enviar correo <BiMailSend style={{ fontSize: '20px' }} />
                </Button>
              </Col>
            </Row>
          </Stack>
        </Col>
      </Row>
    </Paper>
  );
};

export default FormResponseDetail;
